import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <PublicLayout>
      <SEO title="Page not found | NewStarAds" description="The page you're looking for doesn't exist." />
      <section className="max-w-2xl mx-auto px-5 py-32 text-center">
        <p className="font-display font-black text-8xl tracking-tighter text-primary/20">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/"><Button className="rounded-full"><Home className="w-4 h-4 mr-1" /> Home</Button></Link>
          <Link to="/services"><Button variant="outline" className="rounded-full">View Services</Button></Link>
        </div>
      </section>
    </PublicLayout>
  );
}
